App.factory('userInvitationService', ['Config', 'baseService', function (Config, baseService) {
    function UserInvitationService() {
        this.sendInvitations = function (params) {
            return baseService.post(Config.API_URL + "/userInvitation", params).then(
                function (success) {
                    return success;
                }, function (error) {
                    return error;
                });
        }

        this.getInvitations = function () {
            return baseService.get(Config.API_URL + "/userInvitation").then(
                function (success) {
                    return success;
                }, function (error) {
                    return error;
                });
        }

        this.getInvitation = function (invitationToken) {
            return baseService.getWithOutAuth(Config.API_URL + "/userInvitation/" + invitationToken).then(
                function (success) {
                    return success;
                }, function (error) {
                    return error;
                });
        }

        this.declineInvitation = function (invitationToken) {
            return baseService.getWithOutAuth(Config.API_URL + "/userInvitation/" + invitationToken + "/decline").then(
                function (success) {
                    return success;
                }, function (error) {
                    return error;
                });
        }
    }

    return new UserInvitationService();
}]);